import styled from "styled-components";

export const PillStyled = styled('div')(() => ({
  display: 'flex',
  width: 'fit-content',
  alignItems: 'center',
  padding: '4px 8px 4px 8px',
  borderRadius: '4px',
}));